export default [
    {
        path: '/signatures/document-types',
        name: 'signatures-document-types',
        component: () => import ('./views/DocumentTypeIndex'),
        meta: {
            title: 'Tipos de documentos para assinaturas',
            icon: 'mdi-file-document',
            breadcrumbs: [
                { text: 'Lista de tipos de documentos para assinaturas', disabled: true }
            ]
        }
    },
]
